<template>
    <div class="col-12 col-lg-6 g c">
        <div class="card card-body">
            <div class="form-group">
              <span for="">اسم المدرسة</span>
              <input type="text"
                class="form-control" v-model="user.name" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <span for="">شعار المدرسة</span>
              <input type="file"
                class="form-control" id="ingredient_file" @change="uploadImage()" accept=".jpg,.png,.gif,.jpeg">
            </div>
            <div class="form-group">
              <span for="">المنطقة</span>
              <select class="form-control" v-model="user.settings.gover">
                <option :value="null">-- اختر --</option>
                <option v-for="go in govers" :key="go.code" :value="go.name">{{ go.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <span for="">العنوان (عنوان المدرسة)</span>
              <input type="text"
                class="form-control" v-model="user.settings.address" placeholder="اكتب هنا...">
            </div>
            <div class="form-check">
              <span>
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="user.settings.hijri" :value="true">
                    استعراض تواريخ النظام بالتاريخ الهجري بدلاً من الميلادي.
                </label>
              </span>
            </div>
            <div class="form-check">
              <span>
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="user.settings.no_system_freedays" :value="true" :unchecked-value="false">
                    عدم استخدام الاجازات والعطلات الرسمية التي يقدمها النظام.
                </label>
              </span>
            </div>
            <div class="form-check">
              <span>
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="user.settings.no_forward_admin" :value="true" :unchecked-value="false">
                    عدم السماح للمعلمين بالتحويل للموجه مباشرة.
                </label>
              </span>
            </div>
            <div class="form-check">
              <span>
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="user.settings.require2FA" :value="true" :unchecked-value="false">
                    تفعيل المصادقة الثنائية (طلب كود دخول في رسالة عند تسجيل الدخول).
                </label>
              </span>
            </div>
            <div class="g">
                ترتيب الطلاب في النظام حسب 
                <select v-model="user.settings.order_students_by">
                    <option value="name_desc">الاسم تصاعدياً</option>
                    <option value="name_asc">الاسم تنازلياً</option>
                    <option value="date">تاريخ الاضافة</option>
                </select>
            </div>
            <div class="form-group">
                <label for="">الرقم الضريبي</label>
                <input type="text"
                class="form-control" v-model="user.settings.tax_number" placeholder="اكتب هنا...">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="save()">
                    حفظ
                </button>
            </div>
            <a href="javascript:;" @click="changepass=!changepass" style="margin-top: 10px; border: 1px solid #eee; padding: 10px; background: #fafafa; width: 50%;"><i class="fa fa-key"></i> تغيير كلمة المرور</a>
            <div class="card card-body border col-12 col-lg-8" v-if="changepass" style="margin-top: 20px">
                <div class="form-group">
                  <label for="">كلمة المرور القديمة</label>
                  <input type="text"
                    class="form-control" v-model="old_password" placeholder="اكتب هنا...">
                </div>
                <div class="form-group">
                  <label for="">كلمة المرور الجديدة</label>
                  <input type="text"
                    class="form-control" v-model="new_password" placeholder="اكتب هنا...">
                </div>
                <div class="col-12 text-center">
                    <button class="btn btn-danger" @click="changepassnow()">
                        تغيير كلمة المرور الآن
                    </button>
                </div>
            </div>
            <a href="javascript:;" class="text-danger" @click="clear=!clear" style="margin-top: 5px; border: 1px solid #eee; padding: 10px; background: #fafafa; width: 50%;"><i class="fa fa-trash"></i> حذف بيانات الحساب</a>
            <div class="card card-body border col-12 col-lg-8" v-if="clear" style="margin-top: 20px">
                <div class="form-group">
                  <label for="">الفترة من</label>
                  <input type="date"
                    class="form-control" v-model="from">
                </div>
                <div class="form-group">
                  <label for="">الفترة الى</label>
                  <input type="date"
                    class="form-control" v-model="to">
                </div>
                اختر المراد حذفه:
                <div class="form-check" v-for="c in clears" :key="c.code">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="selected_clear" :value="c.code">
                    {{ c.title }}
                  </label>
                </div>
                <hr>
                <div class="form-group">
                  <h5 for="">كلمة المرور</h5>
                  <input type="password"
                    class="form-control" v-model="password" placeholder="اكتب كلمة المرور...">
                  <small id="helpId" class="form-text text-muted">كلمة المرور الخاصة بتسجيل الدخول لتأكيد الحذف</small>
                </div>
                <hr>
                <div class="col-12 text-center">
                    <button class="btn btn-danger" @click="clearNow()">
                        حذف البيانات الآن
                    </button>
                </div>
            </div>
            <a href="javascript:;" class="text-success" v-b-modal.og style="margin-top: 5px; border: 1px solid #eee; padding: 10px; background: #fafafa; width: 50%;"><i class="fa fa-whatsapp"></i> <i class="fa fa-link"></i> التحكم في شكل الروابط المرسلة</a>
            <b-modal id="og" title="تصميم الروابط" hide-footer size="lg">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                          <h5 for="">العنوان (اسم المدرسة)</h5>
                          <input type="text"
                            class="form-control form-control-lg" v-model="title" placeholder="اكتب هنا...">
                        </div>
                        <div class="form-group">
                          <h5 for="">الوصف</h5>
                          <textarea class="form-control form-control-lg" v-model="description" rows="3" placeholder="اكتب هنا..."></textarea>
                        </div>
                        <div class="form-group">
                        <h5 for="">الشعار / الصورة</h5>
                        <input type="file"
                            class="form-control" id="ingredient_file2" @change="uploadImage2()" accept=".jpg,.png,.gif,.jpeg">
                        </div>
                        <div class="col-12 text-center g">
                            <button class="btn btn-success" @click="saveOG()">
                                <i class="fa fa-check"></i>
                                حفظ الاعدادات
                            </button>
                        </div>
                    </div>
                    <div class="col-12 col-lg-5">
                        <img :src="require('@/assets/images/og-wa.png')" style="width: 100%; border-radius: 10px;" alt="">
                    </div>
                </div>
            </b-modal>
            <a href="javascript:;" class="text-primary dnone " v-b-modal.sessions @click="getSessions()" style="margin-top: 5px; border: 1px solid #eee; padding: 10px; background: #fafafa; width: 50%;"><i class="fa fa-clock-o"></i> سجل دخول المستخدمين</a>
            <b-modal id="sessions" title="سجل المستخدمين" hide-footer size="lg">
                <div class='col-12 table-responsive'>
                    <table class="table table-hover table-bordered table-sm">
                        <thead>
                            <th>
                                نوع الحساب
                            </th>
                            <th>
                                الاسم
                            </th>
                            <th>
                                اسم المستخدم
                            </th>
                            <th>
                                التاريخ
                            </th>
                            <th>
                                الحالة
                            </th>
                            <th>
                                خيارات
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="session in sessions" :key="session._id">
                                <td>
                                    {{ session.admin_id == "" ? 'المسؤول' : 'مشرف' }}
                                </td>
                                <td>
                                    {{ session.name }}
                                </td>
                                <td>
                                    {{ session.username }}
                                </td>
                                <td>
                                    {{ session.last_update }}
                                </td>
                                <td>
                                    <span v-if="session.status == 0" class="text-warning">في الانتظار</span>
                                    <span v-if="session.status == 1" class="text-success">مقبول</span>
                                    <span v-if="session.status == 2" class="text-warning">مرفوض</span>
                                </td>
                                <td>
                                    <a v-if="session.status != 1" :href="api + '/general/session/' + session._id" target="_blank"><i class="fa fa-edit"></i> قبول/رفض</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            selected_clear: [],
            password: "",
            tax_number: "",
            title: "",
            description: "",
            sessions: [],
            viewSessions: false,
            image: "",
            api: api,
            clears: [
                {
                    title: "الطلاب",
                    code: "students"
                },
                {
                    title: "المعلمين",
                    code: "teachers"
                },
                {
                    title: "تقارير الطلاب",
                    code: "students_reports"
                },
                {
                    title: "تقارير المعلمين",
                    code: "teachers_reports"
                },
                {
                    title: "الرسائل",
                    code: "messages"
                },
                {
                    title: "البصمات المرفوعة",
                    code: "fingerprints"
                },
                {
                    title: "تحضير الحصص",
                    code: "lessons"
                },
                {
                    title: "المحادثات",
                    code: "chats"
                },
                {
                    title: "طلبات المناداة",
                    code: "calls"
                },
                {
                    title: "المخالفات السلوكية",
                    code: "bis"
                },
                {
                    title: "الزيارات",
                    code: "visits"
                },
                {
                    title: "ساعات التطوع",
                    code: "hours"
                },
            ],
            changepass: false,
            clear: false,
            from: new Date().toISOString().split("T")[0], //"2024-08-01",
            to: new Date().toISOString().split("T")[0],
            old_password: "",
            new_password: "",
            user: JSON.parse(localStorage.getItem('user')),
            logo: require('@/assets/images/school.png'),
            govers: [ { "name": "الشرقية", "code": "07922030894897314" }, { "name": "الرياض", "code": "3464519167295701" }, { "name": "مكة المكرمة", "code": "9845567573740195" }, { "name": "المدينة المنورة", "code": "349759219773605" }, { "name": "القصيم", "code": "8810910303387001" }, { "name": "الحدود الشمالية", "code": "5725350578269051" }, { "name": "تبوك", "code": "4711089187842914" }, { "name": "عسير", "code": "8015620891099577" }, { "name": "حائل", "code": "801829036756802" }, { "name": "جازان", "code": "7483951746859658" }, { "name": "الجوف", "code": "9728923495226371" }, { "name": "نجران", "code": "05716017271974416" }, { "name": "الباحة", "code": "380720566426884" }, { "name": "الأحساء", "code": "7439002774861188" }, { "name": "الطائف", "code": "7301093814581201" }, { "name": "جدة", "code": "9324439662394386" }, { "name": "ظهران الجنوب", "code": "36362863019571345" }, { "name": "الخرج", "code": "011878215082641752" }, { "name": "عفيف", "code": "7633053797678944" }, { "name": "المذنب", "code": "9972443874694372" }, { "name": "عنيزة", "code": "10387946978759377" }, { "name": "محايل عسير", "code": "9486976969075793" }, { "name": "البكيرية", "code": "7582720715225275" }, { "name": "الأفلاج", "code": "835207330564983" }, { "name": "الغاط", "code": "08847367829007369" }, { "name": "القويعية", "code": "5133375227967814" }, { "name": "النماص", "code": "012059878023488624" }, { "name": "الليث", "code": "36341045678359873" }, { "name": "مهد الذهب", "code": "632273077853188" }, { "name": "شقراء", "code": "39658195959561615" }, { "name": "وادي الدواسر", "code": "41904064226512805" }, { "name": "الرس", "code": "9571464042089053" }, { "name": "الزلفي", "code": "8478267524821435" }, { "name": "العلا", "code": "5539822140080306" }, { "name": "المخواة", "code": "11743501331324824" }, { "name": "سراة عبيدة", "code": "6334792607995348" }, { "name": "الدوادمي", "code": "24117940735274424" }, { "name": "ينبع", "code": "38854563091021066" }, { "name": "القنفذة", "code": "6627349813398269" }, { "name": "بيشة", "code": "34666473529096065" }, { "name": "رجال ألمع", "code": "47730011267382544" }, { "name": "القريات", "code": "038064976779219384" }, { "name": "المجمعة", "code": "6829918461558238" }, { "name": "حفر الباطن", "code": "8085986861954995" }, { "name": "صبيا", "code": "8803200128100506" }, { "name": "شرورة", "code": "7882025128260539" }, { "name": "حوطة بني تميم و الحريق", "code": "6659241332109906" } ]
        }
    },
    created(){
        if(!checkPer("settings")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        if(g.user?.settings?.logo && g.user?.settings?.logo != "null"){
            g.logo = g.user?.settings?.logo
        }
        if(!g?.user?.settings?.gover){
            g.user.settings.gover = null
        }
        $.get(api + '/general/og?id=' + g.user._id, {
        }).then(function(r){
            g.title = r.title;
            g.description = r.description;
        })
    },
    methods: {
        getSessions(){
            var g = this;
            $.post(api + '/user/auth/sessions', {
            jwt: this.user.jwt
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response, 200)
            }else{
                g.sessions = r.response
            }
        }).fail(function(){
            alert("حدث خطأ في الاتصال", 200)
        })
        },
        clearNow(){
            var g = this;
            if(confirm("متأكد من حذف البيانات المحددة في الفترة المحددة؟")){
                if(confirm("بعد الحذف لا يمكنك التراجع عن هذا الاجراء, متأكد من الحذف؟")){
                    $.post(api + '/user/auth/clear', {
                        jwt: this.user.jwt,
                        password: this.password,
                        selected: this.selected_clear,
                        from: this.from,
                        to: this.to
                    }).then(function(r){
                        if(r.status != 100){
                            alert(r.response, 200)
                        }else{
                            alert("تم الحذف بنجاح", 100)
                        }
                    }).fail(function(){
                        alert("حدث خطأ في الاتصال", 200)
                    })
                }
            }
        },
        changepassnow(){
            var g = this;
             $.post(api + '/user/auth/change-password', {
                jwt: this.user.jwt,
                old_password: this.old_password,
                new_password: this.new_password
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    alert("تم التغيير بنجاح", 100)
                    g.$router.push("/logout");
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        },
        save(){
            var g = this;
             $.post(api + '/user/general/settings/save', {
                jwt: this.user.jwt,
                name: this.user.name,
                logo: this.user.settings.logo,
                gover: this.user.settings.gover,
                hijri: this.user.settings.hijri,
                address: this.user.settings.address,
                order_students_by: this.user.settings.order_students_by,
                no_system_freedays: this.user.settings.no_system_freedays,
                no_forward_admin: this.user.settings.no_forward_admin,
                require2FA: this.user.settings.require2FA,
                tax_number: this.user.settings.tax_number
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    $.post(api + "/user/auth/check", {
                        jwt: g.user.jwt,
                    }).then(function(r){
                        localStorage.setItem("user", JSON.stringify(r.response));
                    })
                    alert("تم الحفظ", 100)
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        },
        saveOG(){
            var g = this;
             $.post(api + '/user/general/settings/save-og', {
                jwt: this.user.jwt,
                title: this.title,
                description: this.description,
                image: this.image
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    alert("تم الحفظ", 100)
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        },
        uploadImage(){
            var g = this;
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                formData.append("jwt", g.user.jwt);

                $.ajax({
                type: "POST",
                url: api + '/user/general/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    if(data.status != 100){
                        alert("هذه الصورة غير مدعومة", 200)
                        return;
                    }
                    g.user.settings.logo = data.response
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#ingredient_file")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        },uploadImage2(){
            var g = this;
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                formData.append("jwt", g.user.jwt);

                $.ajax({
                type: "POST",
                url: api + '/user/general/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    if(data.status != 100){
                        alert("هذه الصورة غير مدعومة", 200)
                        return;
                    }
                    g.image = data.response
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#ingredient_file2")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        }
    }
}
</script>

<style>

</style>